import React, { useState } from 'react';
import { Dialog, Button, DialogTitle, DialogActions } from '@material-ui/core';
import Strapi from '../../services/strapi';
import { useNotification } from '../../contexts/Notification';

interface AuthorRemoveInterface {
    id: number,
    onRemove: () => void,
}

const AuthorRemove = (props: AuthorRemoveInterface) => {
    const [open, setOpen] = useState<boolean>(false);
    const notification = useNotification();

    return <>
        <Button onClick={() => {
            setOpen(true);
        }}>Supprimer</Button>
        <Dialog open={open} onClose={() => {
            setOpen(false);
        }}>
            <DialogTitle>Confirmer la supression</DialogTitle>
            <DialogActions>
                <Button color="secondary" onClick={() => {
                    Strapi.delete(`authors/${props.id}`).then((r) => {
                        notification.notify("Removed");
                    }).catch(e => {
                        notification.notify("Fail to remove", "error");
                    }).finally(() => {
                        setOpen(false);
                        props.onRemove();
                    });
                }}>Supprimer</Button>
                <Button onClick={() => {
                    setOpen(false);
                }}>Annuler</Button>
            </DialogActions>
        </Dialog>
    </>
}

export default AuthorRemove;